import {
  department_cards,
  employee_departments,
  employee_filters,
  employee_rows,
  employee_statuses,
  outstanding_sections,
  register_cards,
  tabs
} from './employee_register_data';
import { employee_drawers_a } from './employee_register_drawers_a';
import { employee_drawers_b } from './employee_register_drawers_b';
import { create_employee_form, employee_register_computed, employee_register_methods } from './employee_register_helper';

const employee_drawers = {
  ...employee_drawers_a,
  ...employee_drawers_b
};

export default {
  name: 'ComplyonEmployees',
  data: () => ({
    tabs,
    active_tab: 'register',
    register_cards,
    employee_filters,
    active_employee_filter: 'all',
    employee_rows,
    outstanding_sections,
    department_cards,
    employee_departments,
    employee_statuses,
    employee_drawers,
    show_employee_modal: false,
    active_employee_drawer: null,
    employee_form: create_employee_form()
  }),
  computed: { ...employee_register_computed },
  methods: { ...employee_register_methods }
};
